namespace e5.ScrollViewLimit {
    class ScrollViewLimitAuto implements IScrollViewLimit {
        public getMinX(view: ScrollView, scale: number = view.scale): number {
            var rw = view.contentWidth * scale;
            if (rw < view.width) {
                return Center.getMinX(view, scale);
            }
            return Cover.getMinX(view, scale);
        }

        public getMaxX(view: ScrollView, scale: number = view.scale): number {
            var rw = view.contentWidth * scale;
            if (rw < view.width) {
                return Center.getMaxX(view, scale);
            }
            return Cover.getMaxX(view, scale);
        }

        public getMinY(view: ScrollView, scale: number = view.scale): number {
            var rh = view.contentHeight * scale;
            if (rh < view.height) {
                return Center.getMinY(view, scale);
            }
            return Cover.getMinY(view, scale);
        }

        public getMaxY(view: ScrollView, scale: number = view.scale): number {
            var rh = view.contentHeight * scale;
            if (rh < view.height) {
                return Center.getMaxY(view, scale);
            }
            return Cover.getMaxY(view, scale);
        }
    }

    export const Auto = new ScrollViewLimitAuto();
}